import { gql } from "gql";

export const VIEW_POST = gql(/* GraphQL */ `
  mutation ViewPost($id: ID!) {
    viewPost(id: $id)
  }
`);
